import { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as CarReferenceSelectors from 'store/carReference/selectors';

export const useFieldsControl = () => {
  const dispatch = useDispatch();

  const isNew = useSelector(
    CarInstanceSelectors.selectValuesField(CarInstanceConstants.VALUE_FIELDS.IS_NEW)
  );
  const disabledList = useSelector(
    CarInstanceSelectors.selectField(CarInstanceConstants.STORE_FIELDS.DISABLE_FIELDS)
  );
  const hiddenList = useSelector(
    CarInstanceSelectors.selectField(CarInstanceConstants.STORE_FIELDS.HIDDEN_FIELDS)
  );
  const selectedBrand = useSelector(CarReferenceSelectors.selectSelectedBrand);
  const selectedModel = useSelector(CarReferenceSelectors.selectSelectedModel);

  const { id: selectedBrandId } = selectedBrand ?? {};
  const { id: selectedModelId } = selectedModel ?? {};

  const disabled = useMemo(() => {
    return new Set(disabledList);
  }, [disabledList]);
  const hidden = useMemo(() => {
    return new Set(hiddenList);
  }, [hiddenList]);

  // Скрываем или показываем пробег если изменили состояние авто
  useEffect(() => {
    if (isNew) {
      hidden.add(CarInstanceConstants.VALUE_FIELDS.MILEAGE);
      hidden.delete(CarInstanceConstants.VALUE_FIELDS.VERSION);
    } else {
      hidden.delete(CarInstanceConstants.VALUE_FIELDS.MILEAGE);
      hidden.add(CarInstanceConstants.VALUE_FIELDS.VERSION);
    }

    dispatch(CarInstanceActions.setCarHiddenFields(Array.from(hidden)));
  }, [isNew]);

  // Блокируем поле модель если не выбрана марка
  useEffect(() => {
    if (!selectedBrandId) {
      disabled.add(CarInstanceConstants.VALUE_FIELDS.MODEL);
    } else {
      disabled.delete(CarInstanceConstants.VALUE_FIELDS.MODEL);
    }

    dispatch(CarInstanceActions.setCarDisableFields(Array.from(disabled)));
  }, [selectedBrandId]);

  // Блокируем поле комплектация если не выбрана модель
  useEffect(() => {
    if (!selectedModelId) {
      disabled.add(CarInstanceConstants.VALUE_FIELDS.VERSION);
    } else {
      disabled.delete(CarInstanceConstants.VALUE_FIELDS.VERSION);
    }

    dispatch(CarInstanceActions.setCarDisableFields(Array.from(disabled)));
  }, [selectedModelId]);
};
